'use strict';

const States = require('feedback/domain/value/idea-state');
const _ = require('underscore');

const statesByName = {};
_.each(States, s => {
    statesByName[s.name] = s;
});

class StateFactory {
    static build(name) {
        return statesByName[name];
    }
}

module.exports = StateFactory;



// WEBPACK FOOTER //
// ./feedback/domain/factory/idea-state.js